import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { WelcomeBonusForm } from './WelcomeBonusForm/WelcomeBonusForm';
import { WelcomeBonusListItem } from './WelcomeBonusListItem/WelcomeBonusItem';
import { WelcomeBonusType } from 'src/AppState/WelcomeBonusState/WelcomeBonusState';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const WelcomeBonus = observer(() => {
    const { welcomeBonusState } = useAppStateContext();
    const { isLoading, welcomeBonusElementsList } = welcomeBonusState;
    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={isLoading}>
                        <Loader isActive={isLoading} />
                        {welcomeBonusElementsList.map((welcomeBonus: WelcomeBonusType) => {
                            return welcomeBonus.id !== null && welcomeBonus.id !== undefined ? (
                                <WelcomeBonusListItem key={welcomeBonus.id} welcomeBonus={welcomeBonus} />
                            ) : null;
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>
                <ColumnOneOfTwo>
                    <WelcomeBonusForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
